/* DVRZI mega menu
   - opens on hover with a short intent delay, closes with a grace period
   - a real mouse click on a top level item navigates to that collection
   - keyboard and touch keep the native <details> toggle behaviour
*/
(function () {
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 220;

  function canHover() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.matchMedia('(min-width: 990px)').matches
    );
  }

  function closeOthers(current) {
    document.querySelectorAll('.dvrzi-mega[open]').forEach(function (el) {
      if (el !== current && typeof el.dvrziClose === 'function') el.dvrziClose();
    });
  }

  function setup(details) {
    if (details.dataset.dvrziBound === 'true') return;
    details.dataset.dvrziBound = 'true';

    var summary = details.querySelector('summary');
    if (!summary) return;

    var wrapper = details.closest('header-menu') || details;
    var openTimer = null;
    var closeTimer = null;

    function clearTimers() {
      if (openTimer) clearTimeout(openTimer);
      if (closeTimer) clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    }

    function open() {
      closeOthers(details);
      if (!details.open) details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (details.open) details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    }

    details.dvrziClose = close;

    wrapper.addEventListener('mouseenter', function () {
      if (!canHover()) return;
      clearTimers();
      openTimer = setTimeout(open, OPEN_DELAY);
    });

    wrapper.addEventListener('mouseleave', function () {
      if (!canHover()) return;
      clearTimers();
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    summary.addEventListener('click', function (event) {
      var href = summary.getAttribute('data-href');

      // event.detail is 0 for clicks generated by the keyboard.
      if (canHover() && href && event.detail > 0) {
        event.preventDefault();
        clearTimers();
        window.location.href = href;
        return;
      }

      window.requestAnimationFrame(function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });

    details.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      clearTimers();
      close();
      summary.focus();
    });
  }

  function init() {
    document.querySelectorAll('.dvrzi-mega').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
